import * as React from 'react';
//import CityCohort from "../components/filters/CityCohort"


const Admin = () => {
    return(
        <div>
            <button>Add an Upcoming Class</button>
        </div>
    )
}

export default Admin;